/**
 * Person logueado
 */

import { IPreferences } from './preferences';

export interface IPerson {
  identifier: string;
  name: string;
  surname1: string;
  surname2: string;
  tradeName: string;
  corporateName: string;
  code: string;
  address: string;
  phone: string;
  description: string;
  preferences: IPreferences;
  authorizedOfInvoicingService: boolean;
}

export const emptyPerson: IPerson = {
  identifier: '',
  name: '',
  surname1: '',
  surname2: '',
  tradeName: '',
  corporateName: '',
  code: '',
  address: '',
  phone: '',
  description: '',
  preferences: null,
  authorizedOfInvoicingService: false
};




// WEBPACK FOOTER //
// ./src/app/model/person.ts